

// import React, { useState, useEffect } from 'react'; 
// import {
//   Box,
//   IconButton,
//   Tooltip,
//   Menu,
//   MenuItem,
//   Typography,
//   ListItemButton,
//   useMediaQuery,
//   useTheme,
//   Avatar, 
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import MenuIcon from '@mui/icons-material/Menu';
// import LogoutIcon from '@mui/icons-material/Logout';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import { useNavigate } from 'react-router-dom';

// const GradientText = styled('span')({
//   display: 'inline-block',
//   background: 'linear-gradient(45deg, #120346, #1a237e)',
//   WebkitBackgroundClip: 'text',
//   WebkitTextFillColor: 'transparent',
//   fontWeight: 900,
//   fontSize: '1.2rem',
// });

// const Topbar = ({ toggleSidebar }) => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const [anchorEl, setAnchorEl] = useState(null);

//   // --- LOGIC START: Logged in user cha name kadhnyathi ---
//   const [employeeName, setEmployeeName] = useState('');

//   useEffect(() => {
//     const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
//     if (userData.username) {
//       setEmployeeName(userData.username);
//     }
//   }, []);
//   // --- LOGIC END ---

//   const handleMenu = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLogout = () => {
//     localStorage.clear(); // Clear local storage on logout
//     navigate('/');
//   };

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         height: '65px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         bgcolor: 'rgba(255,255,255,0.9)',
//         backdropFilter: 'blur(10px)',
//         px: { xs: 1, sm: 2, md: 3 },
//         boxShadow: '0px 2px 10px rgba(0,0,0,0.05)',
//         position: 'sticky',
//         top: 0,
//         zIndex: 1100,
//         overflow: 'visible',
//       }}
//     >
//       <Box
//         sx={{
//           width: '100%',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           gap: 1,
//         }}
//       >
//         {/* LEFT SECTION */}
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
//           <IconButton
//             onClick={toggleSidebar}
//             sx={{
//               bgcolor: '#f8fafc',
//               borderRadius: '10px',
//               width: 42,
//               height: 42,
//               flexShrink: 0,
//               '&:hover': { bgcolor: '#eef2ff' },
//             }}
//           >
//             <MenuIcon sx={{ color: '#1e293b' }} />
//           </IconButton>

//           {!isMobile && (
//             <Typography variant="subtitle1" sx={{ fontWeight: 700, letterSpacing: 1, whiteSpace: 'nowrap' }}>
//               <GradientText>Varadvinayak CRM</GradientText>
//             </Typography>
//           )}
//         </Box>

//         {/* CENTER LINE (Visual divider) */}
//         {!isMobile && (
//           <Box sx={{ flexGrow: 1, mx: 4, height: '3px', bgcolor: '#f1f5f9', borderRadius: '10px', overflow: 'hidden' }}>
//             <Box sx={{ width: '40%', height: '100%', bgcolor: '#ff0000', borderRadius: '10px' }} />
//           </Box>
//         )}

//         {/* RIGHT SECTION: Employee Name ani Profile Icon */}
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
//            {/* PROFILE ICON */}
//           <IconButton
//             onClick={handleMenu}
//             sx={{
//               width: 42,
//               height: 42,

//               bgcolor: 'rgba(26, 35, 126, 0.05)',
//               '&:hover': { bgcolor: 'rgba(26, 35, 126, 0.1)' }
//             }}
//           >
//             <AccountCircleIcon sx={{ color: '#1a237e', fontSize: 34,   }} />
//           </IconButton>

//           {/* USER NAME DISPLAY */}
//           {!isMobile && (
//             <Box sx={{ textAlign: 'right', mr: 5 }}>
//               <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a237e', lineHeight: 1 }}>
//                 {employeeName || 'User'}
//               </Typography>
//               <Typography sx={{ fontSize: '10px', color: '#64748b', fontWeight: 500 }}>
//                 Logged In
//               </Typography>
//             </Box>
//           )}



//           {/* PROFILE MENU */}
//           <Menu
//             anchorEl={anchorEl}
//             open={Boolean(anchorEl)}
//             onClose={handleClose}
//             sx={{ mt: 1 }}
//             PaperProps={{
//                 sx: { borderRadius: '12px', minWidth: 150, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }
//             }}
//           >
//             <Box sx={{ px: 2, py: 1, borderBottom: '1px solid #f1f5f9', mb: 1 }}>
//                 <Typography sx={{ fontWeight: 700, fontSize: '14px' }}>{employeeName}</Typography>
//             </Box>
//             <MenuItem onClick={handleClose}>My Profile</MenuItem>
//             <MenuItem onClick={handleLogout} sx={{ color: '#d32f2f' }}>
//               <LogoutIcon sx={{ fontSize: 18, mr: 1 }} /> Logout
//             </MenuItem>
//           </Menu>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Topbar;

import React, { useState, useEffect } from 'react';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router-dom';

const GradientText = styled('span')({
  display: 'inline-block',
  background: 'linear-gradient(45deg, #120346, #1a237e)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 900,
  whiteSpace: 'nowrap',
  // fontSize काढा इथून
});
const Topbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState(null);
  const [employeeName, setEmployeeName] = useState('');

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
    if (userData.username) setEmployeeName(userData.username);
  }, []);

  const handleMenu = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleLogout = () => { localStorage.clear(); navigate('/'); };

  // Initials for mobile avatar
  const initials = employeeName
    ? employeeName.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase()
    : 'U';

  return (
    <Box
      sx={{
        width: '100%',
        height: { xs: '56px', sm: '65px' },
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(10px)',
        px: { xs: 1.5, sm: 2, md: 3 },
        boxShadow: '0px 2px 10px rgba(0,0,0,0.05)',
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>

        {/* LEFT: Hamburger + Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          <IconButton
            onClick={toggleSidebar}
            size="small"
            sx={{
              bgcolor: '#f8fafc',
              borderRadius: '10px',
              width: { xs: 36, sm: 42 },
              height: { xs: 36, sm: 42 },
              flexShrink: 0,
              '&:hover': { bgcolor: '#eef2ff' },
            }}
          >
            <MenuIcon sx={{ color: '#1e293b', fontSize: { xs: 20, sm: 24 } }} />
          </IconButton>

          {/* Logo — desktop only */}
          {!isMobile && (
            <GradientText style={{ fontSize: 'clamp(0.75rem, 3.5vw, 1.1rem)' }}>
              Varadvinayak CRM
            </GradientText>
          )}

          {/* Mobile: show CRM name compact next to hamburger */}
          {isMobile && (
            <GradientText style={{ fontSize: 'clamp(0.75rem, 3.5vw, 1.1rem)' }}>
              Varadvinayak CRM
            </GradientText>
          )}
        </Box>

        {/* CENTER: Decorative divider — desktop only */}
        {!isMobile && (
          <Box sx={{ flexGrow: 1, mx: 4, height: '3px', bgcolor: '#f1f5f9', borderRadius: '10px', overflow: 'hidden' }}>
            <Box sx={{ width: '40%', height: '100%', bgcolor: '#ff0000', borderRadius: '10px' }} />
          </Box>
        )}

        {/* RIGHT: User info + Profile icon */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.8, sm: 1 }, flexShrink: 0 }}>

          {/* Desktop: name text */}
          {!isMobile && (
            <Box sx={{ textAlign: 'right', mr: 1 }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a237e', lineHeight: 1 }}>
                {employeeName || 'User'}
              </Typography>
              <Typography sx={{ fontSize: '10px', color: '#64748b', fontWeight: 500 }}>
                Logged In
              </Typography>
            </Box>
          )}

          {/* Mobile: initials avatar bubble */}
          {isMobile ? (
            <Box
              onClick={handleMenu}
              sx={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                bgcolor: '#1a237e',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                flexShrink: 0,
                '&:hover': { bgcolor: '#0f1f5c' },
              }}
            >
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#fff', lineHeight: 1, userSelect: 'none' }}>
                {initials}
              </Typography>
            </Box>
          ) : (
            <IconButton
              onClick={handleMenu}
              sx={{
                width: 42,
                height: 42,
                bgcolor: 'rgba(26,35,126,0.05)',
                borderRadius: '50%',
                '&:hover': { bgcolor: 'rgba(26,35,126,0.1)' },
              }}
            >
              <AccountCircleIcon sx={{ color: '#1a237e', fontSize: 34 }} />
            </IconButton>
          )}

          {/* Dropdown menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            sx={{ mt: 1 }}
            PaperProps={{
              sx: {
                borderRadius: '12px',
                minWidth: 170,
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <Box sx={{ px: 2, py: 1, borderBottom: '1px solid #f1f5f9', mb: 0.5 }}>
              <Typography sx={{ fontWeight: 700, fontSize: '14px', color: '#1a237e' }}>
                {employeeName || 'User'}
              </Typography>
              <Typography sx={{ fontSize: '11px', color: '#64748b' }}>Logged In</Typography>
            </Box>
            <MenuItem onClick={handleClose} sx={{ fontSize: '14px', gap: 1 }}>
              <AccountCircleIcon sx={{ fontSize: 18, color: '#64748b' }} />
              My Profile
            </MenuItem>
            <MenuItem onClick={handleLogout} sx={{ color: '#d32f2f', fontSize: '14px', gap: 1 }}>
              <LogoutIcon sx={{ fontSize: 18 }} />
              Logout
            </MenuItem>
          </Menu>
        </Box>

      </Box>
    </Box>
  );
};

export default Topbar;